<template>
  <div>
    <snackbarcomp
      v-bind:mesaj="text1"
      v-model="snackbar"
      v-bind:color="snackbarkColor"
    ></snackbarcomp>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <doviz ref="doviz" @setCurrencyValue="setCurrency($event)"></doviz>

    <v-form ref="flightSearchForm">
      <v-card class="rounded-corner pa-2 elevation-3 mt-3 mx-2">
        <v-flex xs12 sm12 md12 px-4 py-2>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3>
              <v-autocomplete
                :items="airportsItems"
                hide-details=""
                clearable
                :label="$t('Departure-Airport')"
                hide-no-data
                cache-items
                v-model="searchParams.Departure"
                :rules="[(v) => !!v || $t('Mandatory-section')]"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-autocomplete
                prepend-icon="shuffle"
                :items="airportsItems"
                hide-details=""
                clearable
                :label="$t('Arrival-Airport')"
                v-model="searchParams.Destination"
                :rules="[(v) => !!v || $t('Mandatory-section')]"
              >
                <template v-slot:prepend>
                  <v-slide-x-reverse-transition mode="out-in">
                    <v-icon
                    color="primary"
                      @click="shuffleAirline()"
                    >connecting_airports</v-icon>
                  </v-slide-x-reverse-transition>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <tarihim
                :etiket="$t('Departure-Date')"
                :detaygizle="false"
                v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"
                v-model="searchParams.DepartureDay"
              >
              </tarihim>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <tarihim
                :etiket="$t('Arrival-Date')"
                :detaygizle="false"
                v-bind:defaultvalue="'ok'"
                :aktifmi="roundTrip"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"
                v-model="searchParams.DestinationDay"
              >
              </tarihim>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-layout row wrap>
                <v-radio-group
                  v-model="searchParams.FlightType"
                  @change="checkWay(searchParams.FlightType)"
                  row
                >
                  <v-radio :label="$t('One-Way')" value="OW"></v-radio>
                  <v-radio :label="$t('Return-v3')" value="RT"></v-radio>
                </v-radio-group>
                <!-- <v-flex xs12 sm6 md6>
                  <v-checkbox
                    label="Tek Yon"
                    v-model="searchParams.OneWay"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-checkbox
                    label="Gidis Donus"
                    v-model="searchParams.RoundTrip"
                  ></v-checkbox>
                </v-flex> -->
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md3 pr-4>
              <v-menu
                :close-on-content-click="false"
                bottom
                origin="center center"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" outline block dark v-on="on">
                    {{ passengerCount }} Yolcu <v-icon right>people</v-icon>
                  </v-btn>
                </template>
                <v-card
                  class="pa-3"
                  style="max-width: 600px"
                  v-if="
                    $vuetify.breakpoint.sm ||
                    $vuetify.breakpoint.md ||
                    $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.xl
                  "
                >
                  <v-list class="pt-4">
                    <v-list-tile>
                      <v-list-tile-content class="pl-2 pt-5 pb-5">
                        <number
                          :name="$t('Adult')"
                          @passengerValue="passengerCountCheck($event)"
                          description="12-65"
                          :totalValue="passengerCount"
                          value="1"
                          v-model="searchParams.Adult"
                        ></number>
                      </v-list-tile-content>
                      <v-list-tile-content class="pl-2 pt-5 pb-5">
                        <number
                          :name="$t('Child')"
                          description="2-12"
                          v-model="searchParams.Child"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                      <v-list-tile-content class="pl-2 pt-5 pb-5 pr-1">
                        <number
                          :name="$t('Baby')"
                          description="0-2"
                          v-model="searchParams.Baby"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-list class="pt-4">
                    <v-list-tile>
                      <v-list-tile-content class="pl-2 pt-5 pb-5">
                        <number
                          :name="$t('Student')"
                          description="13-24"
                          v-model="searchParams.Student"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                      <v-list-tile-content class="pl-2 pt-5 pb-5">
                        <number
                          :name="$t('Young')"
                          v-model="searchParams.Young"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                      <v-list-tile-content class="pl-2 pt-5 pb-5 pr-1">
                        <number
                          :name="$t('65Age')"
                          v-model="searchParams.Old"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-list class="pt-4">
                    <v-list-tile>
                      <v-list-tile-content class="pl-2 pt-5 pb-5 pr-1">
                        <number
                          :name="$t('Soldier')"
                          v-model="searchParams.Soldier"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                      <v-list-tile-content
                        style="visibility: collapse"
                        class="pl-2"
                      >
                        <number
                          :name="$t('Soldier')"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                      <v-list-tile-content
                        style="visibility: collapse"
                        class="pl-2 pt-5 pb-5"
                      >
                        <number
                          :name="$t('Soldier')"
                          @passengerValue="passengerCountCheck($event)"
                          :totalValue="passengerCount"
                        ></number>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card>

                <v-card v-if="$vuetify.breakpoint.xs" three-line>
                  <v-list class="px-3">
                    <v-list-tile-content>
                      <number
                        :name="$t('Adult')"
                        description="12-65"
                        value="1"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                        v-model="searchParams.Adult"
                      ></number>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <number
                        :name="$t('Child')"
                        description="2-12"
                        v-model="searchParams.Child"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                      ></number>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <number
                        :name="$t('Baby')"
                        description="0-2"
                        v-model="searchParams.Baby"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                      ></number>
                    </v-list-tile-content>
                  </v-list>

                  <v-list class="px-3">
                    <v-list-tile-content>
                      <number
                        :name="$t('Student')"
                        description="13-24"
                        v-model="searchParams.Student"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                      ></number>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <number
                        :name="$t('Young')"
                        v-model="searchParams.Young"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                      ></number>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <number
                        :name="$t('65Age')"
                        v-model="searchParams.Old"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                      ></number>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <number
                        :name="$t('Soldier')"
                        v-model="searchParams.Soldier"
                        @passengerValue="passengerCountCheck($event)"
                        :totalValue="passengerCount"
                      ></number>
                    </v-list-tile-content>
                  </v-list>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <cariaracomp
                v-bind:etiket="$t('Current-Account')"
                v-model="searchParams.Accouting"
              ></cariaracomp>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-select
                :label="$t('Cabin')"
                :items="cabinItems"
                item-text="name"
                item-value="value"
                hide-details
                v-model="searchParams.Cabin"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                label="Markup"
                v-model="searchParams.Markup"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex
              v-if="
                $vuetify.breakpoint.md ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.xl
              "
              xs12
              sm2
              md2
            >
              <v-btn color="info" block outline @click="getTokenv2()"
                >{{ $t('Search-Flight-Tickets') }} <v-icon right>expand_more</v-icon></v-btn
              >
            </v-flex>

            <v-flex
              v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
              xs12
              sm6
            >
              <v-btn color="info" block @click="getTokenv2()"
                >  {{ $t('Search-Flight-Tickets') }} </v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card>

      <!-- Filtreler -->
      <v-flex xs12 sm12 md12 pa-2 v-if="controlTicketList.length > 0">
        <v-layout row justify-start>
          <v-card flat color="grey lighten-5">
            <v-layout row wrap justify-space-between>
              <v-flex xs12 sm2 md2>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" outline dark v-on="on">
                      {{  $t('Ticket-Prices') }}
                    </v-btn>
                  </template>

                  <v-card class="px-4 pt-5 pb-1" height="120" width="100%">
                    <v-slider
                      :thumb-size="50"
                      thumb-label="always"
                      v-model="filter.ticketPrice"
                      :max="filterTicketMaxPrice"
                      @change="filterTicketList(1)"
                    ></v-slider>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 md4>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" outline dark v-on="on">
                      {{ $t('Departure-Arrival-Hours') }}
                    </v-btn>
                  </template>

                  <v-card class="pa-2">
                    <v-subheader> {{ $t('Departure-Hours') }} </v-subheader>

                    <v-card-text>
                      <v-layout row>
                        <v-flex shrink style="width: 70px">
                          <v-text-field
                            v-model="filter.timeDepartureRange[0]"
                            class="mt-0"
                            hide-details
                            single-line
                            type="number"
                            suffix=":00"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="px-3">
                          <v-range-slider
                            v-model="filter.timeDepartureRange"
                            :max="max"
                            :min="min"
                            @change="filterTicketList(2)"
                          ></v-range-slider>
                        </v-flex>
                        <v-flex shrink style="width: 70px">
                          <v-text-field
                            v-model="filter.timeDepartureRange[1]"
                            class="mt-0"
                            hide-details
                            single-line
                            type="number"
                            suffix=":00"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-subheader>Varis Saati</v-subheader>

                    <v-card-text>
                      <v-layout row>
                        <v-flex shrink style="width: 70px">
                          <v-text-field
                            v-model="filter.timeDestinationRange[0]"
                            class="mt-0"
                            hide-details
                            single-line
                            type="number"
                            suffix=":00"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="px-3">
                          <v-range-slider
                            v-model="filter.timeDestinationRange"
                            :max="maxDestination"
                            :min="minDestination"
                            @change="filterTicketList(3)"
                          ></v-range-slider>
                        </v-flex>
                        <v-flex shrink style="width: 70px">
                          <v-text-field
                            v-model="filter.timeDestinationRange[1]"
                            class="mt-0"
                            hide-details
                            single-line
                            type="number"
                            suffix=":00"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 md2>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" outline dark v-on="on">
                      {{ $t('Price-Type-v2') }}
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-checkbox
                            :label="$t('Flexible')"
                            v-model="filter.flex"
                            @change="filterTicketList(7)"
                          ></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile>
                        <v-list-tile-action>
                          <v-checkbox
                            :label="$t('Promotion')"
                            v-model="filter.promo"
                            @change="filterTicketList(8)"
                          ></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 md2>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" outline dark v-on="on">
                      {{ $t('Transfer-v2') }}
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-checkbox
                            :label="$t('Direct')"
                            v-model="filter.direct"
                            @change="filterTicketList(4)"
                          ></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile>
                        <v-list-tile-action>
                          <v-checkbox
                            :label="'1+' + $t('Transfer-v2') "
                            v-model="filter.transfer"
                            @change="filterTicketList(5)"
                          ></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 md2>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" outline dark v-on="on">
                      {{ $t('Airways') }}
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-tile
                        v-for="airline in filter.airline"
                        :key="airline.name"
                      >
                        <v-checkbox
                          :label="airline.name"
                          @change="filterTicketList(6, airline)"
                          v-model="airline.value"
                        ></v-checkbox>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card>
        </v-layout>
      </v-flex>

      <!-- gun degistir -->

      <!-- tek yon -->
      <v-flex
        xs12
        sm12
        md12
        pa-2
        v-if="controlTicketList.length > 0 && searchParams.FlightType == 'OW'"
      >
        <v-layout row wrap>
          <v-flex shrink pa-1>
            <v-card>
              <v-card-actions>
                <v-btn color="indigo" flat @click="getPrevDayTicketList()">
                  <v-icon left>navigate_before</v-icon>
                   {{ $t('Previous-Day') }} 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex grow pa-1 style="text-align: center">
            <v-card>
              <v-card-actions
                v-if="searchParams.DepartureDay != null"
                style="display: block"
              >
                <v-btn color="indigo" flat>
                  {{ formatDate(searchParams.DepartureDay) }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex shrink pa-1>
            <v-card>
              <v-card-actions>
                <v-btn color="indigo" flat @click="getNextDayTicketList()"
                  >  {{ $t('Next-Day') }}
                  <v-icon right>navigate_next</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Gidis donus -->
      <v-layout
        row
        wrap
        v-if="searchParams.FlightType == 'RT' && controlTicketList.length > 0"
      >
        <v-flex xs12 sm12 md6 pa-2>
          <v-layout row wrap>
            <v-flex shrink pa-1>
              <v-card>
                <v-card-actions>
                  <v-btn color="indigo" flat @click="getPrevDayTicketList()">
                    <v-icon left>navigate_before</v-icon>
                    {{ $t('Previous-Day') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex grow pa-1 style="text-align: center">
              <v-card>
                <v-card-actions
                  v-if="searchParams.DepartureDay != null"
                  style="display: block"
                >
                  <v-btn color="indigo" flat>
                    {{ formatDate(searchParams.DepartureDay) }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex shrink pa-1>
              <v-card>
                <v-card-actions>
                  <v-btn color="indigo" flat @click="getNextDayTicketList()"
                    >  {{ $t('Next-Day') }}
                    <v-icon right>navigate_next</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm12 md6 pa-2 v-if="controlTicketList.length > 0">
          <v-layout row wrap>
            <v-flex shrink pa-1>
              <v-card>
                <v-card-actions>
                  <v-btn
                    color="indigo"
                    flat
                    @click="getPrevDayDestinationTicketList()"
                  >
                    <v-icon left>navigate_before</v-icon>
                    {{ $t('Previous-Day') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex grow pa-1 style="text-align: center">
              <v-card>
                <v-card-actions
                  v-if="searchParams.DestinationDay != null"
                  style="display: block"
                >
                  <v-btn color="indigo" flat>
                    {{ formatDate(searchParams.DestinationDay) }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex shrink pa-1>
              <v-card>
                <v-card-actions>
                  <v-btn
                    color="indigo"
                    flat
                    @click="getNextDayDestinationTicketList()"
                    >  {{ $t('Next-Day') }}
                    <v-icon right>navigate_next</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import Airports from "@/components/app/satis/ucak/airports.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import number from "@/components/app/customcomp/number.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth.js";
import doviz from "@/components/app/muhasebe/comp/doviz.vue";

export default {
  components: {
    tarihim,
    cariaracomp,
    number,
    snackbarcomp,
    loadingcomp,
    doviz,
  },
  data() {
    return {
      roundTrip: true,
      controlTicketList: [],
      filterTicketMaxPrice: 0,
      filter: {
        type: 0,
        ticketPrice: 0,
        timeDepartureRange: [0, 24],
        timeDestinationRange: [0, 24],
        transfer: true,
        direct: true,
        flex: true,
        promo: true,
        airline: [],
        currency: 0,
      },
      loadingvmodel: false,
      min: 0,
      max: 24,
      maxDestination: 24,
      minDestination: 0,
      slider: 40,
      range: [0, 24],
      passengerCount: 1,
      snackbarkColor: null,
      text1: null,
      snackbar: false,
      searchParams: Airports.nextSearchParams(),
      flightSearchParams: Airports.bookingSearchParams(),
      cabinItems: Airports.cabins(),
      airportsItems: Airports.airports(),
      passengerItem: Airports.AirSearchPaxItems(),
      segmentItem: Airports.AirSearchSegments(),
    };
  },
  mounted() {
    this.$refs.doviz.getCurrencyValue("EUR");
  },
  methods: {
    shuffleAirline(){

      let departure = this.searchParams.Departure; 
      let destination = this.searchParams.Destination;
      
      this.searchParams.Departure = destination;
      this.searchParams.Destination = departure;

    },
    setCurrency(val) {
      this.currencyValue = val;
    },
    moneyformat(m) {
      if (m != 0) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      } else {
        return 0;
      }
    },
    checkWay(val) {
      if (val == "RT") {
        this.roundTrip = false;
      } else {
        this.roundTrip = true;
      }
    },
    formatDate(a) {
      var date = new Date(a);
      var formatDate = helpers.dateformat(date);

      return formatDate;
    },
    getNextDayDestinationTicketList() {
      if (this.$refs.flightSearchForm.validate()) {
        var date = new Date(this.searchParams.DestinationDay);
        date.setDate(date.getDate() + 1);
        var formatDate = helpers.dateformat(date);
        var parseFormDate = formatDate.split(".");
        var nextDate =
          parseFormDate[2] + "-" + parseFormDate[1] + "-" + parseFormDate[0];
        var nextDateTime = nextDate + "T00:00:00";

        this.searchParams.DestinationDay = nextDateTime;
        this.getTokenv2();
      }
    },
    getPrevDayDestinationTicketList() {
      if (this.$refs.flightSearchForm.validate()) {
        var date = new Date(this.searchParams.DestinationDay);
        date.setDate(date.getDate() - 1);
        var formatDate = helpers.dateformat(date);
        var parseFormDate = formatDate.split(".");
        var prevDate =
          parseFormDate[2] + "-" + parseFormDate[1] + "-" + parseFormDate[0];
        var prevDateTime = prevDate + "T00:00:00";

        this.searchParams.DestinationDay = prevDateTime;
        this.getTokenv2();
      }
    },
    getNextDayTicketList() {
      if (this.$refs.flightSearchForm.validate()) {
        var date = new Date(this.searchParams.DepartureDay);
        date.setDate(date.getDate() + 1);
        var formatDate = helpers.dateformat(date);
        var parseFormDate = formatDate.split(".");
        var nextDate =
          parseFormDate[2] + "-" + parseFormDate[1] + "-" + parseFormDate[0];
        var nextDateTime = nextDate + "T00:00:00";

        this.searchParams.DepartureDay = nextDateTime;
        this.getTokenv2();
      }
    },
    getPrevDayTicketList() {
      if (this.$refs.flightSearchForm.validate()) {
        var date = new Date(this.searchParams.DepartureDay);
        date.setDate(date.getDate() - 1);
        var formatDate = helpers.dateformat(date);
        var parseFormDate = formatDate.split(".");
        var prevDate =
          parseFormDate[2] + "-" + parseFormDate[1] + "-" + parseFormDate[0];
        var prevDateTime = prevDate + "T00:00:00";

        this.searchParams.DepartureDay = prevDateTime;
        this.getTokenv2();
      }
    },
    filterTicketList(value, airline) {
      this.filter.currency = this.currencyValue;
      this.filter.type = value;
      if (airline !== undefined) {
        let controlAirline = this.filter.airline.findIndex(
          (p) => p.name == airline.name
        );
        if (this.filter.airline[controlAirline].value) {
          this.filter.airline[controlAirline].value = true;
        } else {
          this.filter.airline[controlAirline].value = false;
        }
      }
      this.$emit("filterList", this.filter);
    },
    passengerCountCheck(value) {
      this.passengerCount = this.passengerCount + Number(value);
    },
    getTokenv2()
    {
      this.loadingvmodel = true;
      var params = {
        Username: "Arkgsa",
  Password: "3paPVcsbbpf5Lwj",
  IsTest: true

      };

      this.$http
        .post("https://testbookingapi.arkman.com.tr/" + "Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            window.localStorage.setItem(
              "bookingParams",
              JSON.stringify(response.body)
            );
            this.getTickets();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
     getToken() {
            if (this.$refs.flightSearchForm.validate()) {
        this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 1,
      };

      this.$http
        .post(auth.API_URL + "api/Booking/Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            window.localStorage.setItem(
              "bookingParams",
              JSON.stringify(response.body)
            );
            this.getTickets();

           // burasi tetiklenicek emit. this.ActiveType = response.body.Active;
          },
          (response) => {
            if (response.status === 0) {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-BookingLogin";
              this.snackbar = true;
            } else {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-BookingLogin";
              this.snackbar = true;
            }
          }
        );
      }
    },
    getTickets() {
      if (this.$refs.flightSearchForm.validate()) {
        var bookingParams = JSON.parse(
          window.localStorage.getItem("bookingParams")
        );

        this.flightSearchParams.SessionHeader.SessionId =
          bookingParams.SessionId;
        this.flightSearchParams.SessionHeader.SessionToken =
          bookingParams.SessionToken;
        this.flightSearchParams.AirSearchOptions.MarkupFareList =
          this.searchParams.Markup / this.currencyValue;
        this.flightSearchParams.AirSearchOptions.CompanyCode =
          this.searchParams.Accouting;
        this.flightSearchParams.AirSearchOptions.FlightType =
          this.searchParams.FlightType;
        this.flightSearchParams.AirSearchOptions.CabinType =
          this.searchParams.Cabin;
        this.preparePassengers();
        this.prepareSearchSegments();

        this.flightSearchParams.AirSearchOptions.Currency = "TRY";
        // if(bookingParams.AuthenticatedUser.Currency == null){
        //   this.flightSearchParams.AirSearchOptions.Currency = "TRY";
        // }else{
        //   this.flightSearchParams.AirSearchOptions.Currency = bookingParams.AuthenticatedUser.Currency;
        // }
        this.$http
          .post( 'https://testbookingapi.arkman.com.tr/' + "Air/Search", this.flightSearchParams)
          .then(
            (response) => {

              if (!response.body.HasError) {
                this.$emit("setFlightType", this.searchParams.FlightType);

                //Filtre gorunumlerini kontrol icin ataniyor.
                this.controlTicketList = response.body.OriginDestinationOptions;

                if (response.body.OriginDestinationOptions.length != 0) {
                  this.$emit(
                    "showList",
                    response.body.OriginDestinationOptions
                  );

                  // Filtreler icin Bilet Listesinden max fiyat bulunuyor.
                  let maxItem = response.body.OriginDestinationOptions.reduce(
                    (max, min) => (max.TotalFare > min.TotalFare ? max : min)
                  );
                  var ticketMaxPrice = maxItem.TotalFare;
                  this.filterTicketMaxPrice = parseInt(ticketMaxPrice, 10) + 1;
                  this.filter.ticketPrice = parseInt(ticketMaxPrice, 10) + 1;

                  response.body.OriginDestinationOptions.forEach((element) => {
                    element.FlightSegments.forEach((flightElement) => {
                      var airline = {
                        name: flightElement.MarkettingAirlineName,
                        code: flightElement.MarkettingAirline,
                        value: true,
                      };
                      var controlAirline = this.filter.airline.findIndex(
                        (p) => p.name == flightElement.MarkettingAirlineName
                      );
                      if (controlAirline == -1) {
                        this.filter.airline.push(airline);
                      }
                    });
                  });
                } else {
                  this.text1 = this.$t('NO-FLIGHT-HAS-BEEN-FOUND-FOR-DATES-SELECTED');
                  this.snackbar = true;
                }

                this.loadingvmodel = false;
              } else {
                //.
                if (
                  response.body.ServiceError.ErrorMessages[0] ==
                    "SessionToken boş olmamalıdır." ||
                  response.body.ServiceError.ErrorMessages[0] ==
                    "Session bulunamadı."
                ) {
                  setTimeout(
                    function () {
                      this.getTickets();
                    }.bind(this),
                    1200
                  );
                } else {
                  this.text1 = response.body.ServiceError.ErrorMessages[0];
                  this.snackbar = true;
                  this.loadingvmodel = false;
                  this.snackbarkColor = "warning";
                }
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/Search";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/Search";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      } else {
        this.snackbar = true;
        this.text1 = "Lutfen Zorunlu Alanlari Doldurunuz.";
        this.snackbarkColor = "warning";
      }
    },
    prepareSearchSegments() {
      this.flightSearchParams.AirSearchSegments = [];
      var _origin = this.searchParams.Departure.split("-");
      var _destination = this.searchParams.Destination.split("-");

      if (this.searchParams.FlightType == "RT") {
        // Gidis Donus Aramalar

        let _segment = Airports.AirSearchSegments();
        _segment.SequenceNo = 1;
        _segment.DepartureDay = this.searchParams.DepartureDay;


        if(_origin[1].trim() == 'ISTT'){
          _segment.Origin.AirportCode =  "IST";
          _segment.Origin.IsCity = true;
        }else{
          _segment.Origin.AirportCode = _origin[1].replace(/^\s+|\s+$/g, "");
          _segment.Origin.IsCity = false;
        }

        if(_destination[1].trim() == 'ISTT'){
          _segment.Destination.AirportCode =  "IST";
          _segment.Destination.IsCity = true;
        }else{
        _segment.Destination.AirportCode = _destination[1].replace(
          /^\s+|\s+$/g,
          ""
        );          
        _segment.Destination.IsCity = false;
        }


        let _segmentRT = Airports.AirSearchSegments();
        _segmentRT.SequenceNo = 2;
        _segmentRT.DepartureDay = this.searchParams.DestinationDay;


        if(_origin[1].trim() == 'ISTT'){
          _segmentRT.Origin.AirportCode =  "IST";
          _segmentRT.Origin.IsCity = true;
        }else{
          _segmentRT.Origin.AirportCode = _origin[1].replace(/^\s+|\s+$/g, "");
          _segmentRT.Origin.IsCity = false;
        }
        
        if(_destination[1].trim() == 'ISTT'){
          _segmentRT.Destination.AirportCode =  "IST";
          _segmentRT.Destination.IsCity = true;
        }else{
        _segmentRT.Destination.AirportCode = _destination[1].replace(
          /^\s+|\s+$/g,
          ""
        );          
        _segmentRT.Destination.IsCity = false;
        }


        this.flightSearchParams.AirSearchSegments.push(_segment);
        this.flightSearchParams.AirSearchSegments.push(_segmentRT);
      } else {
     
        let _segment = this.segmentItem;
        _segment.SequenceNo = 1;
        _segment.DepartureDay = this.searchParams.DepartureDay;
        
        if(_origin[1].trim() == 'ISTT'){
          _segment.Origin.AirportCode =  "IST";
          _segment.Origin.IsCity = true;
        }else{
          _segment.Origin.AirportCode = _origin[1].replace(/^\s+|\s+$/g, "");
          _segment.Origin.IsCity = false;
        }

        if(_destination[1].trim() == 'ISTT'){
          _segment.Destination.AirportCode =  "IST";
          _segment.Destination.IsCity = true;
        }else{
        _segment.Destination.AirportCode = _destination[1].replace(
          /^\s+|\s+$/g,
          ""
        );          
        _segment.Destination.IsCity = false;
        }

        
        this.flightSearchParams.AirSearchSegments.push(_segment);
      }
    },
    preparePassengers() {
      this.flightSearchParams.AirSearchPaxItems = [];
      if (this.searchParams.Adult != 0) {
        let _adult = Airports.AirSearchPaxItems();
        _adult.PaxCode = "ADT";
        _adult.PaxCount = this.searchParams.Adult;
        this.flightSearchParams.AirSearchPaxItems.push(_adult);
      }
      if (this.searchParams.Child != 0) {
        let _child = Airports.AirSearchPaxItems();
        _child.PaxCode = "CHD";
        _child.PaxCount = this.searchParams.Child;
        this.flightSearchParams.AirSearchPaxItems.push(_child);
      }
      if (this.searchParams.Baby != 0) {
        let _baby = Airports.AirSearchPaxItems();
        _baby.PaxCode = "INF";
        _baby.PaxCount = this.searchParams.Baby;
        this.flightSearchParams.AirSearchPaxItems.push(_baby);
      }
      if (this.searchParams.Old != 0) {
        let _old = Airports.AirSearchPaxItems();
        _old.PaxCode = "SRC";
        _old.PaxCount = this.searchParams.Old;
        this.flightSearchParams.AirSearchPaxItems.push(_old);
      }
      if (this.searchParams.Student != 0) {
        let _student = Airports.AirSearchPaxItems();
        _student.PaxCode = "STD";
        _student.PaxCount = this.searchParams.Student;
        this.flightSearchParams.AirSearchPaxItems.push(_student);
      }
      if (this.searchParams.Soldier != 0) {
        let _soldier = Airports.AirSearchPaxItems();
        _soldier.PaxCode = "MIL";
        _soldier.PaxCount = this.searchParams.Soldier;
        this.flightSearchParams.AirSearchPaxItems.push(_soldier);
      }

      if (this.searchParams.Young != 0) {
        let _young = Airports.AirSearchPaxItems();
        _young.PaxCode = "YTH";
        _young.PaxCount = this.searchParams.Young;
        this.flightSearchParams.AirSearchPaxItems.push(_young);
      }
    },
  },
  watch: {
      "searchParams.DepartureDay": function(val) {
      this.searchParams.DestinationDay = val;
    },
    "searchParams.RoundTrip": function (val) {
      if (val) {
        this.searchParams.OneWay = false;
        this.roundTrip = false;
      }
    },
    "searchParams.OneWay": function (val) {
      if (val) {
        this.roundTrip = true;
        this.searchParams.RoundTrip = false;
      }
      if (!val && !this.searchParams.RoundTrip) {
        this.searchParams.OneWay = true;
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style scoped>
.rounded-corner {
  border-start-start-radius: 20px;
  border-end-end-radius: 20px;
}
</style>
